import { useTranslations } from '@vocab/react';
import { Text, Stack, Loader, Box } from 'braid-design-system';
import React from 'react';

import translations from '../../locales.vocab';
import { PageSection } from '../PageSection';

const LoadingChecking = () => {
  const { t } = useTranslations(translations);

  return (
    <PageSection heading={t('payment.methods')}>
      <Box paddingY={{ mobile: 'large', tablet: 'xxlarge', desktop: 'gutter' }}>
        <Stack space="large" align="center">
          <Loader />
          {/* <IconSaveTime /> */}
          <Stack space="medium" align="center">
            <Text size="large" weight="strong" align="center">
              {t('payment.loading.header')}
            </Text>
            <Text align="center">{t('payment.loading.message')}</Text>
            <Text align="center">{t('payment.loading.message2')}</Text>
          </Stack>
        </Stack>
      </Box>
    </PageSection>
  );
};

export default LoadingChecking;
